import { useEffect, useState, useContext } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Login from "../pages/login";
import PrivateRoute from "./private-route";
import NotFound from "../pages/not-found";
import Home from "../pages/home";
import { getOfflineData } from "../utils/offline-services";
import { ADMIN_ROUTES, OEM_ROUTES } from "./config";
import { USER_ROLES } from "../utils/constants";
import ForgotPassword from "../pages/forgot-password";
import ResetPassword from "../pages/reset-password";
import AppContext from "../utils/context";
import DeleteAccount from "../pages/delete-account";

const AppRoutes = () => {
  const { userDetails = {} } = useContext(AppContext);
  const createRoutesRenderElement = ({ routes = [] }) => {
    return routes.map((route) => (
      <Route key={route.path} path={route.path} element={route.component} />
    ));
  };

  const roleWiseRouteRender = (role) => {
    switch (role) {
      case USER_ROLES.OEM:
        return createRoutesRenderElement({
          routes: OEM_ROUTES,
        });
      case USER_ROLES.ADMIN:
        return createRoutesRenderElement({
          routes: ADMIN_ROUTES,
        });
      default:
        return null;
    }
  };

  return (
    <Router>
      <Routes>
        <Route exact path="/" element={<Home />}></Route>
        <Route
          exact
          path="/forgot-password/:type"
          element={<ForgotPassword />}
        ></Route>
        <Route exact path="/reset-password" element={<ResetPassword />}></Route>
        <Route exact path="/login/:type" element={<Login />}></Route>
        <Route exact path="/accouts/delete" element={<DeleteAccount />}></Route>
        {userDetails.role === USER_ROLES.OEM && (
          <Route exact path="/oem" element={<PrivateRoute />}>
            {roleWiseRouteRender(userDetails.role)}
          </Route>
        )}
        {userDetails.role === USER_ROLES.ADMIN && (
          <Route exact path="/admin" element={<PrivateRoute />}>
            {roleWiseRouteRender(userDetails.role)}
          </Route>
        )}

        <Route path="*" element={<NotFound />}></Route>
      </Routes>
    </Router>
  );
};

export default AppRoutes;
